export default "__VITE_ASSET__bbeb3493__"